import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './styles.scss';

class Drawer extends Component {
  constructor() {
    super();
    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.state = {
      isOpen: false,
    };
  }

  toggleDrawer() {
    this.setState(({ isOpen }) => ({
      isOpen: !isOpen,
    }));
  }

  render() {
    const { title } = this.props;
    const { isOpen } = this.state;
    return (
      <div className={classNames(
        'drawer',
        { 'drawer--open': isOpen },
        )}
      >
        <button type="button" className="drawer__toggle" onClick={() => this.toggleDrawer()}>{title}</button>
        <div className="drawer__content">
          {this.props.children}
        </div>
      </div>
    );
  }
}

Drawer.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Drawer;



// WEBPACK FOOTER //
// ./src/app/components/tools/drawer/Drawer.js